import { axiosInstance } from "@/helper/axios-instance";
import { DataAwareResponse, Dictionary } from "../types/types";
import { useMutationWithValidation } from "./useMutationWithValidation";

export function useDictionaryDelete() {
  return useMutationWithValidation({
    mutationFn: async (id: string | undefined) => {
      const response = await axiosInstance({
        method: "DELETE",
        url:  `Dictionary/Delete/${id}`,
      });

      return response.data as DataAwareResponse<Dictionary>;
    },
    retry: 2,
  });
}
